export function getEventStartCountdownText(event, now) {
  const startsAtDate = (() => {
    if (!event) return null;
    const timeStr = event.time || '00:00';
    const [hh, mm = 0] = timeStr.split(':').map((x) => parseInt(x, 10) || 0);
    const d = new Date();
    const dateStr = event.eventDate || event.event_date;
    if (dateStr && /^\d{4}-\d{2}-\d{2}$/.test(String(dateStr))) {
      const [y, m, day] = String(dateStr).split('-').map((x) => parseInt(x, 10));
      d.setFullYear(y, m - 1, day);
    }
    d.setHours(hh, mm, 0, 0);
    return d;
  })();

  const startsAt = startsAtDate ? startsAtDate.getTime() : 0;
  const minutesLeft = startsAt > 0 ? Math.max(0, Math.ceil((startsAt - now) / 60000)) : 0;
  const minuteWord = 'minuutin';

  if (minutesLeft >= 2) {
    return `Tapahtuma alkaa ${minutesLeft} ${minuteWord} kuluttua`;
  }
  if (minutesLeft === 1) {
    return `Tapahtuma alkaa ${minuteWord} kuluttua`;
  }
  return '';
}

